/* Everything right & something left */

.sc-ersl {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  white-space: nowrap;

  &__something {
    margin-right: auto !important;
  }
}
